import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, CircularProgress, Tooltip, Typography, Chip, Divider, IconButton,Pagination  } from '@mui/material';
import { ArrowLeft, Edit3, Book, Mic, Tablet } from 'lucide-react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import {defaultVariables} from "../../../../config";
import Grid from "@mui/material/Grid2";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import {currencySymbol, truncate} from "../../../../config/values";
import NumberField from "../../../components/elements/fields/NumberField";
import {useSnackbar} from "notistack";


const BulkEditProducts = ({  }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [submitLoading, setSubmitLoading] = useState(null);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        loadData();
    }, [currentPage]);

    const loadData = async () => {
        setLoading(true);
        try {
            const loginToken = localStorage.getItem('ACT');
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`,
                },
            };
            const response = await axios.get(
                `${defaultVariables.url}/products/get-bulk?page=${currentPage}`,
                config
            );
            console.log(response.data);
            setProducts(response.data.data);
            setTotalPages(parseInt(response.data.last_page));
        } catch (error) {
            console.error(error.response);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (field, id, index, value) => {
        setProducts((prevProducts) => {
            const updatedProducts = [...prevProducts];
            updatedProducts[index] = { ...updatedProducts[index], [field]: value };
            return updatedProducts;
        });
    };

    const handleBlur = async (field, id, index, value) => {
        setSubmitLoading(id);
        try {
            const loginToken = localStorage.getItem('ACT');
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`,
                },
            };
            const data = new FormData();
            data.append('field', field);
            data.append('id', id);
            data.append('val', value);
            const response = await axios.post(`${defaultVariables.url}/products/set-bulk`, data, config);
            setProducts((prevProducts) => {
                const updatedProducts = [...prevProducts];
                updatedProducts[index] = response.data;
                return updatedProducts;
            });
            enqueueSnackbar(t('valueSubmitted'), { variant: 'success' });
        } catch (error) {
            enqueueSnackbar(t('incorrectValue'), { variant: 'warning' });

        } finally {
            setSubmitLoading(null);
        }
    };

    return (
        <Grid container spacing={2} style={{marginTop:50}}>
            {loading ? (
                <Grid item size={12}>
                    <AppCardLoaderFields />
                </Grid>
            ) : (
                <>
                    {products.map((product, index) => (
                        <Grid size={12} key={product.id}>
                            <Grid container spacing={2} justifyContent="center">
                                <Grid size={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography>
                                        <strong>
                                            {product.name}
                                        </strong>
                                    </Typography>
                                </Grid>

                                <Grid size={{xs:12,md:6}}>
                                    <NumberField
                                        fullWidth
                                        label={t('price')}
                                        variant="outlined"
                                        value={product.price}
                                        endAdornment={currencySymbol}
                                        decimals={2}
                                        min={0}
                                        onChange={(res) => handleInputChange('price', product.id, index, res)}
                                        onBlur={(res) => handleBlur('price', product.id, index, res)}
                                    />
                                </Grid>
                                <Grid size={{xs:12,md:6}}>
                                    <NumberField
                                        fullWidth
                                        label={t('discount_percent')}
                                        variant="outlined"
                                        value={product.discount_percent}
                                        endAdornment="%"
                                        decimals={0}
                                        min={0}
                                        max={99}
                                        onChange={(res) => handleInputChange('discount_percent', product.id, index, res)}
                                        onBlur={(res) => handleBlur('discount_percent', product.id, index, res)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    ))}
                    {!loading && totalPages > 1 && (
                        <Grid item size={12} sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={(e, page) => setCurrentPage(page)}
                                color="primary"
                                size="large"
                            />
                        </Grid>
                    )}
                </>
            )}
        </Grid>
    );
};

export default BulkEditProducts;
